import { render, staticRenderFns } from "./TagCallNoteModal.vue?vue&type=template&id=070e0f53&"
import script from "./TagCallNoteModal.vue?vue&type=script&lang=js&"
export * from "./TagCallNoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports